<template>
    <div>
        <el-card shadow="hover" class="el-card">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="checkedFields" @change="handleCheckedCitiesChange">
                <el-checkbox style="margin-bottom: 10px;" v-for="(item,key) in deviceInfo.pair" :label="key" :key="key" :disabled="key==='DNT'">{{item}}</el-checkbox>
            </el-checkbox-group>
            <el-row style="float: right; padding: 3px 0">
                <el-button size="small" type="primary" @click="setFields">提交</el-button>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import {focusFields} from '@/api/device'
    // import { mapGetters } from 'vuex'
    // import { mapActions } from 'vuex'
    export default {
        name: '',
        data(){
            return {
                checkAll: false,
                isIndeterminate: true,
                checkedFields:[]
            }
        },
        props: {
            isChart:{
                type:Boolean,
                default: false
            },
            isGrid:{
                type:Boolean,
                default: false
            },
            deviceInfo: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        methods:{
            setFields(){
                let data={}
                if(this.isChart){
                    data['charColumns'] = this.checkedFields.join(',')
                }else if(this.isGrid){
                    data['gridColumns'] = this.checkedFields.join(',')
                }
                focusFields(data,this.deviceInfo.id).then(response => {
                    if (response.code != 200){
                        return this.$message.error(response.msg)
                    } else {
                        this.$message.success(response.msg)

                        setTimeout(() => {
                            this.$emit('updateCol', '')
                        }, 1000)
                    }
                })
            },
            handleCheckAllChange(val) {
                this.checkedFields = val ? Object.keys(this.deviceInfo.pair) : []
                this.isIndeterminate = false

                if(this.checkedFields.indexOf('DNT')===-1){
                    this.checkedFields.push('DNT')
                }
                console.log('handleCheckAllChange',val,this.checkedFields)
            },
            handleCheckedCitiesChange(value) {
                console.log(value)
                let checkedCount = value.length
                // console.log('选中长度',checkedCount,value)
                // console.log('字段总长度',Object.keys(this.deviceInfo.pair).length)
                this.checkAll = checkedCount === Object.keys(this.deviceInfo.pair).length
                this.isIndeterminate = checkedCount > 0 && checkedCount < Object.keys(this.deviceInfo.pair).length
            },
            // ...mapActions('device',['setINFO'])
        },
        computed: {
            /*...mapGetters([
                'deviceInfo'
            ])*/
        },
        watch: {

        },
        created(){
            console.log('关注created',this.isChart,this.deviceInfo)
            if(this.isChart){
                this.checkedFields = this.deviceInfo.chartStruct.split(',')
            }else if(this.isGrid){
                this.checkedFields = this.deviceInfo.gridStruct.split(',')
            }else {
                this.checkedFields = []
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-checkbox{
        width: 180px;
    }
</style>
